<script>
import Vue from 'vue'
import WIcon from '../../WIcon/WIcon.vue'

export default Vue.extend({
    name: 'BoolCellRenderer',
    components: {
        WIcon,
    },
    data () {
        return {
            inputValue: false,
        }
    },
    computed: {
        isBool () {
            return typeof this.inputValue === 'boolean'
        },
    },
    created () {
        const { value } = this.params
        this.inputValue = value
    },
    methods: {
        getValue () {
            return this.inputValue
        },
    },
    render (h) {
        const checked = !!this.inputValue
        const props = {
            icon: checked ? 'check-circle' : 'x-circle',
            color: checked ? 'green' : 'red',
            size: 20,
        }
        return h(
            'div',
            {
                class: 'BoolCellRenderer',
            },
            [
                ...(this.isBool ? [h(WIcon, { props })] : []),
            ],
        )
    },
})
</script>
